<!-- Revised on 2025/05/13 by mnavarro -->
<template>
  <a :data-bs-toggle="collapse ? 'collapse' : ''" :href="collapse ? `#${collapseRef}` : collapseRef" :aria-controls="collapseRef"
    aria-expanded="false" class="nav-link" v-bind="$attrs" type="button" @click="isExpanded = !isExpanded">
    <div class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2">
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text ms-1">
      {{ navText }}
    </span>
  </a>
  <div :id="collapseRef" class="collapse">
    <ul class="nav nav-sm flex-column">
      <slot name="list"></slot>
    </ul>
  </div>
</template>

<script>

  export default {
    name: "SidenavCollapse",
    props: {
      collapseRef: {
        type: String,
        required: true
      },
      navText: {
        type: String,
        required: true
      },
      collapse: {
        type: Boolean,
        default: true
      }
    },
  };

</script>